"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelQuote = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var __1 = require("../");
var Carousel_1 = require("../Carousel");
var Spacer_1 = require("../Spacer");
require("./panelQuote.css");
var PanelQuote = /** @class */ (function (_super) {
    __extends(PanelQuote, _super);
    function PanelQuote(props) {
        var _this = _super.call(this, props) || this;
        _this.evaluateSlug = function (slug) {
            return _this.state.indexActive !== 'none' && _this.state.indexActive === slug;
        };
        _this.renderImageBox = function (element) { return (0, jsx_runtime_1.jsx)("div", __assign({ className: "image-holder" }, { children: element.image })); };
        _this.renderSubtitle = function (elem) {
            return (0, function_1.pipe)(O.fromNullable(elem.subtitle), (0, Option_1.map)(function (subtitle) { return ((0, jsx_runtime_1.jsx)(__1.TextFormatter, __assign({ borderless: true, fontStyle: "italic" }, { children: subtitle }))); }), O.toNullable);
        };
        _this.renderCloseIcon = function (slug) {
            return _this.evaluateSlug(slug) ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "close-holder", onClick: function () { return _this.setState({ indexActive: 'none' }); } }, { children: (0, jsx_runtime_1.jsx)(__1.Icon, { icon: "icon_close_dark", size: "xxl" }) }))) : null;
        };
        _this.renderLongText = function (el) {
            return _this.evaluateSlug(el.slug) ? el.longText : null;
        };
        _this.renderNodeToExpand = function (slug) {
            return !_this.evaluateSlug(slug) ? ((0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12, lg: 4 }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "node-to-expand-holder", onClick: function () { return _this.setState({ indexActive: slug }); } }, { children: _this.props.nodeClickToExpand })) }))) : null;
        };
        _this.renderBodyInfo = function (element) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(__1.FlexView.Item, __assign({ xs: 12 }, { children: [(0, jsx_runtime_1.jsx)(__1.TextFormatter, __assign({ borderless: true, fontSize: "std-plus", fontWeight: "bold" }, { children: element.title })), _this.renderSubtitle(element), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 0.8 })] })), (0, jsx_runtime_1.jsxs)(__1.FlexView.Item, __assign({ xs: 12 }, { children: [element.shortText, _this.renderLongText(element)] })), _this.renderNodeToExpand(element.slug)] })); };
        _this.renderResponsive = function () { return ((0, jsx_runtime_1.jsx)(__1.FlexView, __assign({ hAlignContent: "between", gutters: { lr: { xs: 'none', lg: 'sm' } } }, { children: _this.props.elements
                .filter(function (e) { return _this.state.indexActive === 'none' || _this.state.indexActive === e.slug; })
                .map(function (e, i) { return ((0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ className: (0, clsx_1.default)('full-width'), xs: _this.state.indexActive === 'none' ? 6 : 12 }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "panel-quote-content" }, { children: [_this.renderCloseIcon(e.slug), (0, jsx_runtime_1.jsxs)(__1.FlexView, __assign({ vAlignContent: "center", gutters: { lr: { xs: 'none', lg: 'sm' }, b: { xs: 'sm', lg: 'none' } } }, { children: [(0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ lg: !_this.evaluateSlug(e.slug) ? 4 : 2 }, { children: _this.renderImageBox(e) })), (0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ lg: !_this.evaluateSlug(e.slug) ? 8 : 10 }, { children: (0, jsx_runtime_1.jsx)(__1.FlexView, __assign({ hAlignContent: "left" }, { children: _this.renderBodyInfo(e) })) }))] }))] })) }), "rete_responsive_".concat(i))); }) }))); };
        _this.renderMobile = function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "panel-quote-content" }, { children: (0, jsx_runtime_1.jsx)(Carousel_1.Carousel, { type: "default", changeOnTime: 60000 * 3, slides: _this.props.elements.map(function (e, i) { return ({
                    slug: "rete_mobile_".concat(i),
                    slide: ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(__1.FlexView, __assign({ vAlignContent: "center", hAlignContent: "center", gutters: { lr: { xs: 'none', lg: 'sm' }, b: { xs: 'sm', lg: 'none' } } }, { children: [(0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 5 }, { children: _this.renderImageBox(e) })), (0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsxs)(__1.FlexView, __assign({ hAlignContent: "center" }, { children: [_this.renderBodyInfo(e), _this.renderCloseIcon(e.slug)] })) }))] })) }, "rete_mobile_".concat(i))),
                }); }) }) }))); };
        _this.state = {
            indexActive: 'none',
        };
        return _this;
    }
    PanelQuote.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "panel-quote" }, { children: PanelQuote.resolution === 'responsive' ? this.renderResponsive() : this.renderMobile() })));
    };
    PanelQuote.resolution = document.documentElement.clientWidth > 1024 ? 'responsive' : 'mobile';
    return PanelQuote;
}(React.PureComponent));
exports.PanelQuote = PanelQuote;
//# sourceMappingURL=PanelQuote.js.map